// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog.brazil-dialog{box-shadow:none;background-color:#fff;border:4px solid #edbf42;border-radius:0;position:relative;flex-direction:column;overflow-y:visible;max-width:550px}.dialog-content-container{overflow-y:auto}#close-modal{position:absolute;top:-15px;right:-15px;width:30px}#close-modal:hover{cursor:pointer}.v-dialog.brazil-dialog .header h4{font-weight:bold;padding:4px 12px}@media screen and (max-width: 500px){.v-dialog.brazil-dialog .header h4{font-size:18px}}", ""]);
// Exports
module.exports = exports;
